/**
 * コンソールかアラートでエラーメッセージを表示します。
 *
 * @param {string} methodName
 * @param {string} message
 * @param {string} [output='alert'] - 'alert' または 'console'
 * @param {boolean|null} [returnValue=null] - メソッドの戻り値
 * @returns {boolean|string}
 */
export function errorMessage(methodName, message, output = 'alert', returnValue = null) {
    const text = `An error occurred in ${methodName}: ${message}`;

    if (output === 'alert') {
        alert(text);
    } else if (output === 'console' && typeof console.error !== 'undefined') {
        console.error(text);
    }

    return returnValue !== null ? returnValue : text;
}
